let env = "";
let staticEnv = "";

switch (process.env.SERVER_ENV) {
  case "development":
    env = "dev.";
    env = "test.";
    staticEnv = "test.";
    break;
  case "test":
    env = "test.";
    staticEnv = "test.";
    break;
  case "local":
    env = "dev.";
    staticEnv = "dev.";
    break;
  default:
    env = "";
    staticEnv = "";
}

export const host = {
  www: `https://www.${env}8891.com.tw`,
  auto: `https://auto.${env}8891.com.tw`,
  c: `https://c.${env}8891.com.tw`,
  m: `https://m.${env}8891.com.tw`,
  image: `https://c.${staticEnv}8891.com.tw/assets/img/new`,
  imageNew: `https://c.${staticEnv}8891.com.tw/assets/static`,
  upload: "https://upload.8891.com.tw",
  dc: env === "" ? "https://dc.8891.tw/api" : "https://dc.test.8891.com.tw/api",
  im: `im.${env}8891.com.tw`,
  imws: `im.${env}8891.com.tw${env === "" ? ":1218" : ""}`,
  used: `https://usedcar.${env}8891.com.tw`,
  env,
};

const { c, www, dc, upload, used, image } = host;

export const path = {
  newCarApiV1: `${c}/api/v1`,
  newCarApiV2: `${c}/api/v2`,
  newCarApiV3: `${c}/api/v3`,
  newCarApiV4: `${c}/api/v4`,
  newCarApiV5: `${c}/api/v5`,
  usedCarApi: `${www}/oapi`,
  usedCarApiV3: `${www}/api/v3`,
  usedCarApiV4: `${www}/api/v4`,
  uploadApi: `${upload}/v2/upload`,
  collectApi: `${dc}behavioral_push`,
  pushCollectApi: `${dc}/pushDataCollection`,
  provision: `${www}/help-sev.html`,
  disclaimer: `${www}/help-laimer.html`,
  privacy: `${www}/help-pris.html`,
  brandList: `${c}/photoModel-brandList.html`,
  modelList: `${c}/photoModel-info.html`,
  usedApi: `${used}/api`,
  imageUrl: image,
  onlineService: `${www}/help-OnlineServer.html`,
};
